import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Document } from '@tiptap/extension-document';
import { History } from '@tiptap/extension-history';
import { Image } from '@tiptap/extension-image';
import { Italic } from '@tiptap/extension-italic';
import { Link } from '@tiptap/extension-link';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Text as TextExtension } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';

export const defaultExtensions = [
	Document,
	Paragraph,
	TextExtension,
	Bold,
	Italic,
	Underline,
	Link,
	Image.configure({ inline: true }),
	BulletList,
	OrderedList,
	ListItem,
	History,
];
